module.exports = __webpack_public_path__ + "img/22_46.1f7c036e.png";